import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, User, Calendar, MapPin, Send } from 'lucide-react';
import { toast } from 'react-toastify';
import authService from '../services/authService';

const PreliminaryVerification = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [fullName, setFullName] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [kycStatus, setKycStatus] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const profile = await authService.getProfile();
        if (profile) {
          const phone = profile.phone || '';
          const fullName = profile.fullName || '';
          const age = profile.age || '';
          const address = profile.address || '';
          const status = profile.kycStatus || null;

          setPhone(phone);
          setFullName(fullName);
          setAge(age);
          setAddress(address);
          setKycStatus(status);

          // If ALL basic info fields exist, mark as submitted (can't edit anymore)
          // This prevents re-submission after refresh
          if (phone && fullName && age && address) {
            setSubmitted(true);
          }
        }
      } catch (err) {
        toast.error(err.message, { position: 'bottom-left', autoClose: 4000 });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSubmit = async () => {
    // Basic validation
    if (!phone || !fullName || !age || !address) {
      toast.error('Please fill in all fields.', {
        position: 'bottom-left',
        autoClose: 3000,
      });
      return;
    }
    if (!/^\+?[0-9]{7,15}$/.test(phone)) {
      toast.error('Invalid phone number format.', {
        position: 'bottom-left',
        autoClose: 3000,
      });
      return;
    }
    const numericAge = parseInt(age, 10);
    if (isNaN(numericAge) || numericAge < 1 || numericAge > 120) {
      toast.error('Enter a valid age (1-120).', {
        position: 'bottom-left',
        autoClose: 3000,
      });
      return;
    }
    setSaving(true);
    try {
      const updated = await authService.updateProfile({
        phone,
        fullName,
        age: numericAge,
        address,
      });
      setKycStatus(updated?.kycStatus || 'PENDING');
      setSubmitted(true);
      toast.success('Profile submitted for review successfully!', {
        position: 'bottom-left',
        autoClose: 2500,
      });
      if (updated?.kycStatus === 'APPROVED') {
        toast.success('KYC already approved ✅', {
          position: 'bottom-left',
          autoClose: 2000,
        });
      }
    } catch (err) {
      toast.error(err.message, { position: 'bottom-left', autoClose: 4000 });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100vh',
      }}
    >
      <Container fluid className='p-0'>
        {/* Header */}
        <div className='d-flex justify-content-between align-items-center p-3 text-white'>
          <Button
            variant='link'
            onClick={() => navigate(-1)}
            className='text-white p-0'
            aria-label='Back to Account Details'
          >
            <ArrowLeft size={24} />
          </Button>
          <h5 className='mb-0 fw-bold'>Preliminary Verification</h5>
          <div style={{ width: '24px' }}></div>
        </div>

        {/* Main Content */}
        <div
          className='bg-white'
          style={{
            borderTopLeftRadius: '25px',
            borderTopRightRadius: '25px',
            minHeight: 'calc(100vh - 70px)',
          }}
        >
          <div className='p-3 p-sm-4'>
            {/* Status Card */}
            {submitted ? (
              <Card
                className='border-0 shadow-sm mb-3'
                style={{
                  backgroundColor:
                    kycStatus === 'APPROVED'
                      ? '#f0fdf4'
                      : kycStatus === 'REJECTED'
                      ? '#fef2f2'
                      : '#fff7ed',
                }}
              >
                {/* <Card.Body className='p-3 d-flex align-items-start'>
                  <div
                    className='rounded-circle me-2 me-sm-3 d-flex align-items-center justify-content-center flex-shrink-0'
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor:
                        kycStatus === 'APPROVED'
                          ? '#22c55e'
                          : kycStatus === 'REJECTED'
                          ? '#ef4444'
                          : '#f59e0b',
                    }}
                  >
                    <Info size={20} color='white' />
                  </div>
                  <div className='flex-grow-1'>
                    <h6
                      className='fw-semibold mb-1'
                      style={{ fontSize: '0.9rem', color: '#1e293b' }}
                    >
                      {kycStatus === 'APPROVED'
                        ? '✅ Verification Approved'
                        : kycStatus === 'REJECTED'
                        ? '❌ Verification Rejected'
                        : '⏳ Review Pending'}
                    </h6>
                    <p
                      className='mb-0 text-muted'
                      style={{ fontSize: '0.8rem', lineHeight: '1.4' }}
                    >
                      {kycStatus === 'APPROVED'
                        ? 'Your identity has been verified successfully. You can now access all features.'
                        : kycStatus === 'REJECTED'
                        ? 'Your submission was rejected. Please contact support for assistance.'
                        : 'Your profile is under review. We will notify you once verification is complete.'}
                    </p>
                  </div>
                </Card.Body> */}
              </Card>
            ) : null}
            {/* <Card
                className='border-0 shadow-sm mb-3'
                style={{ backgroundColor: '#f0f4ff' }}
              >
                <Card.Body className='p-3 d-flex align-items-start'>
                  <div
                    className='rounded-circle me-2 me-sm-3 d-flex align-items-center justify-content-center flex-shrink-0'
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#667eea',
                    }}
                  >
                    <Info size={20} color='white' />
                  </div>
                  <div className='flex-grow-1'>
                    <h6
                      className='fw-semibold mb-1'
                      style={{ fontSize: '0.9rem', color: '#1e293b' }}
                    >
                      Identity Verification Required
                    </h6>
                    <p
                      className='mb-0 text-muted'
                      style={{ fontSize: '0.8rem', lineHeight: '1.4' }}
                    >
                      Provide accurate details to complete your profile. This
                      helps us verify your identity and secure your account.
                    </p>
                  </div>
                </Card.Body>
              </Card> */}

            {/* Form Card */}
            <Card className='border-0 shadow-sm hover-lift'>
              <Card.Body className='p-3 p-sm-4'>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                  <h6 className='fw-bold mb-0 text-dark'>
                    {submitted ? 'Submitted Information' : 'Basic Information'}
                  </h6>
                  {loading && (
                    <Spinner
                      animation='border'
                      size='sm'
                      role='status'
                      style={{ color: '#667eea' }}
                    />
                  )}
                </div>
                {submitted && (
                  <p
                    className='text-muted mb-3'
                    style={{ fontSize: '0.8rem', lineHeight: '1.3' }}
                  >
                    Below is your submitted profile information under review.
                  </p>
                )}

                <div className='row g-3'>
                  {/* Phone Number */}
                  <div className='col-12'>
                    <Form.Group>
                      <Form.Label
                        className='fw-medium d-flex align-items-center mb-2'
                        style={{ fontSize: '0.85rem', color: '#475569' }}
                      >
                        <div
                          className='rounded-circle me-2 d-flex align-items-center justify-content-center'
                          style={{
                            width: '28px',
                            height: '28px',
                            backgroundColor: '#e0e7ff',
                          }}
                        >
                          <Phone size={14} color='#667eea' />
                        </div>
                        Phone Number *
                      </Form.Label>
                      <Form.Control
                        type='tel'
                        placeholder='e.g., +1234567890'
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        disabled={loading || submitted}
                        style={{
                          padding: '0.75rem 1rem',
                          border: '2px solid #e2e8f0',
                          borderRadius: '10px',
                          fontSize: '0.9rem',
                          transition: 'all 0.2s',
                        }}
                        className='form-input'
                      />
                    </Form.Group>
                  </div>

                  {/* Full Name */}
                  <div className='col-12'>
                    <Form.Group>
                      <Form.Label
                        className='fw-medium d-flex align-items-center mb-2'
                        style={{ fontSize: '0.85rem', color: '#475569' }}
                      >
                        <div
                          className='rounded-circle me-2 d-flex align-items-center justify-content-center'
                          style={{
                            width: '28px',
                            height: '28px',
                            backgroundColor: '#e0e7ff',
                          }}
                        >
                          <User size={14} color='#667eea' />
                        </div>
                        Full Name *
                      </Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter your full legal name'
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        disabled={loading || submitted}
                        style={{
                          padding: '0.75rem 1rem',
                          border: '2px solid #e2e8f0',
                          borderRadius: '10px',
                          fontSize: '0.9rem',
                          transition: 'all 0.2s',
                        }}
                        className='form-input'
                      />
                    </Form.Group>
                  </div>

                  {/* Age */}
                  <div className='col-12'>
                    <Form.Group>
                      <Form.Label
                        className='fw-medium d-flex align-items-center mb-2'
                        style={{ fontSize: '0.85rem', color: '#475569' }}
                      >
                        <div
                          className='rounded-circle me-2 d-flex align-items-center justify-content-center'
                          style={{
                            width: '28px',
                            height: '28px',
                            backgroundColor: '#e0e7ff',
                          }}
                        >
                          <Calendar size={14} color='#667eea' />
                        </div>
                        Age *
                      </Form.Label>
                      <Form.Control
                        type='number'
                        placeholder='Enter your age (18+)'
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        disabled={loading || submitted}
                        min='1'
                        max='120'
                        style={{
                          padding: '0.75rem 1rem',
                          border: '2px solid #e2e8f0',
                          borderRadius: '10px',
                          fontSize: '0.9rem',
                          transition: 'all 0.2s',
                        }}
                        className='form-input'
                      />
                    </Form.Group>
                  </div>

                  {/* Address */}
                  <div className='col-12'>
                    <Form.Group>
                      <Form.Label
                        className='fw-medium d-flex align-items-center mb-2'
                        style={{ fontSize: '0.85rem', color: '#475569' }}
                      >
                        <div
                          className='rounded-circle me-2 d-flex align-items-center justify-content-center'
                          style={{
                            width: '28px',
                            height: '28px',
                            backgroundColor: '#e0e7ff',
                          }}
                        >
                          <MapPin size={14} color='#667eea' />
                        </div>
                        Address *
                      </Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={3}
                        placeholder='Enter your complete residential address'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        disabled={loading || submitted}
                        style={{
                          padding: '0.75rem 1rem',
                          border: '2px solid #e2e8f0',
                          borderRadius: '10px',
                          fontSize: '0.9rem',
                          resize: 'vertical',
                          minHeight: '90px',
                          transition: 'all 0.2s',
                        }}
                        className='form-input'
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Submit Button */}
                <div className='pt-3'>
                  {submitted ? (
                    <Button
                      onClick={() => navigate('/account-details')}
                      className='w-100 py-3 fw-semibold d-flex align-items-center justify-content-center'
                      style={{
                        background:
                          'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                        border: 'none',
                        borderRadius: '12px',
                        boxShadow: '0 4px 15px rgba(100, 116, 139, 0.4)',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <ArrowLeft size={18} className='me-2' />
                      Back to Account Details
                    </Button>
                  ) : (
                    <Button
                      onClick={handleSubmit}
                      disabled={loading || saving}
                      className='w-100 py-3 fw-semibold d-flex align-items-center justify-content-center'
                      style={{
                        background:
                          'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        borderRadius: '12px',
                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s ease',
                        opacity: loading || saving ? 0.7 : 1,
                      }}
                    >
                      {saving ? (
                        <>
                          <Spinner
                            animation='border'
                            size='sm'
                            className='me-2'
                            role='status'
                          />
                          Submitting...
                        </>
                      ) : (
                        <>
                          <Send size={18} className='me-2' />
                          Submit for Review
                        </>
                      )}
                    </Button>
                  )}
                </div>

                {!loading && !submitted && (
                  <div
                    className='text-center text-muted mt-3'
                    style={{ fontSize: '0.75rem', lineHeight: '1.4' }}
                  >
                    * All fields are required. Phone number should include
                    country code.
                  </div>
                )}

                {submitted && (
                  <div
                    className='text-center mt-3 p-2'
                    style={{
                      fontSize: '0.8rem',
                      color: '#64748b',
                      backgroundColor: '#f8fafc',
                      borderRadius: '8px',
                    }}
                  >
                    Your information is locked during review. Contact support if
                    changes are needed.
                  </div>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </Container>

      <style jsx>{`
        .form-input:focus {
          border-color: #667eea !important;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
          outline: none;
        }

        .form-input:disabled {
          background-color: #f8fafc;
          cursor: not-allowed;
        }

        .hover-lift {
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }

        .hover-lift:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12) !important;
        }

        button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
        }

        button:active:not(:disabled) {
          transform: translateY(0);
        }

        @media (max-width: 576px) {
          h5 {
            font-size: 1.1rem !important;
          }
          h6 {
            font-size: 1rem !important;
          }
          .form-input {
            font-size: 0.85rem !important;
          }
        }

        @media (max-width: 380px) {
          h5 {
            font-size: 1rem !important;
          }
          h6 {
            font-size: 0.95rem !important;
          }
          .form-input {
            font-size: 0.8rem !important;
            padding: 0.65rem 0.85rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PreliminaryVerification;
